import { render, staticRenderFns } from "./AccountSecurityPassword.vue?vue&type=template&id=57fa0b9e&scoped=true"
import script from "./AccountSecurityPassword.vue?vue&type=script&lang=js"
export * from "./AccountSecurityPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa0b9e",
  null
  
)

export default component.exports